import { render, staticRenderFns } from "./file-pres-added.vue?vue&type=template&id=a2290822"
import script from "./file-pres-added.vue?vue&type=script&lang=js"
export * from "./file-pres-added.vue?vue&type=script&lang=js"
import style0 from "./file-pres-added.vue?vue&type=style&index=0&id=a2290822&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports